/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'company-hub.spotlight-extension.config-panel.preamble':
    'Destaca los mensajes importantes con un foco visual. {supportLink}',
  'company-hub.spotlight-extension.config-panel.preamble-link.label': 'Más información sobre los puntos destacados',
  'company-hub.spotlight-extension.config-panel.preamble-without-support-link':
    'Destaca los mensajes importantes con un foco visual.',
  'company-hub.spotlight-extension.config-panel.title': 'Foco',
  'company-hub.spotlight-extension.hub-element.description': 'Resalta los mensajes importantes',
  'company-hub.spotlight-extension.hub-element.title': 'Foco',
  'company-hub.spotlight-extension.manifest.initial-state.alt-image-text': 'Fotografía paisajística de desierto',
  'company-hub.spotlight-extension.manifest.initial-state.text-description':
    'Diseña un punto destacado para resaltar la información más importante. Da vida a los mensajes más relevantes con colores personalizados, una imagen llamativa y diseños flexibles.',
  'company-hub.spotlight-extension.manifest.initial-state.text-title': 'Da a tu foco un título',
  'company-hub.spotlight-extension.manifest.macro-description': 'Destaca los mensajes importantes con un foco visual.',
  'company-hub.spotlight-extension.manifest.macro-title': 'Foco',
  'company-hub.spotlight-extension.manifest.macro-title.new': 'Foco [Nuevo]',
  'company-hub.spotlight-extension.spotlight-config-panel.content-tab.label': 'Contenido',
  'company-hub.spotlight-extension.spotlight-config-panel.general-title': 'General',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts-title': 'Diseños',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.description':
    'Cuadro de texto superpuesto en una imagen grande',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.label':
    'Marco de contenidos dentro de la imagen',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.description':
    'Imagen a tamaño completo detrás del contenido',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.label': 'Fondo de la imagen',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.description':
    'Contenido sobre un color de ancho completo',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.label':
    'Fondo de color sólido',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.description':
    'Imagen grande a la derecha con mucho espacio para contenido',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.label':
    'Diseño dividido (primero contenido)',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.description':
    'Imagen grande a la izquierda con mucho espacio para contenido',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.label':
    'Diseño dividido (primero imagen)',
  'company-hub.spotlight-extension.spotlight-config-panel.styles-tab.label': 'Estilos',
  'company-hub.spotlight-extension.spotlight-config-panel.text-description-label': 'Descripción',
  'company-hub.spotlight-extension.spotlight-config-panel.text-description-placeholder':
    'Los puntos destacados resaltan los mensajes importantes para el equipo. Diséñalos con una imagen, tus colores personalizados, una breve descripción y un enlace.',
  'company-hub.spotlight-extension.spotlight-config-panel.text-image-label': 'Imagen',
  'company-hub.spotlight-extension.spotlight-config-panel.text-title-label': 'Título',
  'company-hub.spotlight-extension.spotlight-config-panel.text-title-placeholder': 'Da a tu foco un título',
  'company-hub.spotlight-extension.spotlight.background.color': 'Color de fondo',
  'company-hub.spotlight-extension.spotlight.color-contrast.fail':
    'Los colores del texto y del fondo que has elegido no van bien para facilitar la lectura.',
  'company-hub.spotlight-extension.spotlight.color-contrast.success':
    'Los colores del texto y del fondo que has elegido van bien para facilitar la lectura.',
  'company-hub.spotlight-extension.spotlight.text.color': 'Color del texto',
};
